export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-1.e0d9ec66.png";